import { Injectable } from "@angular/core";
import { createEffect, ofType, Actions } from "@ngrx/effects";
//import { of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import * as type from './actionTypes';
import * as ChangeLogAction from './actions';
import { ChangeLogService } from "./service";

@Injectable()
export class ChangeLogEffect {

    constructor(
        private action: Actions,
        private changeLogService: ChangeLogService
    ) { }

    GetChangeLogs = createEffect(() => this.action.pipe(
        ofType(type.GET_CHANGE_LOG),
        switchMap((data: any) => this.changeLogService.getChangeLogs(data.payload)),
        map((data: Array<any>) => new ChangeLogAction.SetChangeLog(data)
        )
    ));

    DownloadSavedReportByIdAsCsv = createEffect(() => this.action.pipe(
        ofType(type.DOWNLOAD_CHANGE_LOG_CSV),
        switchMap((data: any) => this.changeLogService.downloadChangeLogCsv(data.payload)),
        map((data: any) => new ChangeLogAction.DownloadChangeLogCsvResponse(data))
    ));
}
